import React, { useState, useMemo } from 'react'
import styles from './index.module.scss'

interface ImgListProps {
  srcList1: string;
  srcList2: string;
  onPreview: (src: string, imgList: string[]) => void;
  size?: any
}

const ImgList: React.FC<ImgListProps> = (props) => {
  const { srcList1, srcList2, onPreview, size } = props
  
  const src = useMemo(() => {
    let srcStr = `${srcList1}${srcList1 && srcList2 ? ',' : ''}${srcList2}`
    let srcArr = srcStr.split(',')
    let _src: string = srcArr && srcArr[0] ? srcArr[0] : 'https://cdns.007vin.com/img/autorepair/cst/default_no_part.png'
    return _src
  }, [srcList1, srcList2])
  const previewImg = () => {
    let srcStr = `${srcList1}${srcList1 && srcList2 ? ',' : ''}${srcList2}`
    let srcArr = srcStr.split(',')
    if(srcArr && srcArr[0]) {
      onPreview(src, srcArr)
    }else {
      let _src = 'https://cdns.007vin.com/img/autorepair/cst/default_no_part.png'
      let _srcArr = [_src]
      onPreview(_src, _srcArr)
    }
  }
  console.log(src)
  return (
    <span className={styles['quality-img'] + ' ' + `${size === 'small' ? styles['small'] : ''}`} onClick={previewImg}>
      <img src={src} alt="" />
    </span>
  )
}

export default ImgList